export default __webpack_public_path__ + "static/media/wordHome2.9fa0ed7a.PNG";